var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowPart = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 587 95"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#1916B0",
  strokeWidth: 8,
  d: "M0 47.5h580.5M541.542 3 581.5 47.5 541.542 92"
})));
export { SvgArrowPart as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTg3IiBoZWlnaHQ9Ijk1IiB2aWV3Qm94PSIwIDAgNTg3IDk1IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMCA0Ny41SDU4MC41TTU0MS41NDIgM0w1ODEuNSA0Ny41TDU0MS41NDIgOTIiIHN0cm9rZT0iIzE5MTZCMCIgc3Ryb2tlLXdpZHRoPSI4Ii8+Cjwvc3ZnPgo=";